import { render, staticRenderFns } from "./TestRequest.vue?vue&type=template&id=9020daa8&scoped=true&"
import script from "./TestRequest.vue?vue&type=script&lang=js&"
export * from "./TestRequest.vue?vue&type=script&lang=js&"
import style0 from "./TestRequest.vue?vue&type=style&index=0&id=9020daa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9020daa8",
  null
  
)

export default component.exports